export enum DataSourceType{
  odata = 1,
  api = 2
}
